import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { EnumService } from "src/app/core/services/enum.service";
import { EvaluatorService } from "src/app/core/services/evaluator.service";
import { ToastNotificationService } from "src/app/core/services/toast-notification.service";

@Component({
  selector: "app-evaluator-register",
  templateUrl: "./evaluator-register.component.html",
  styleUrls: ["./evaluator-register.component.css"],
})
export class EvaluatorRegisterComponent implements OnInit {
  officeTypes = [
    {
      name: "Baguio City Police Office - BCPO",
      value: "1",
    },
    {
      name: "City Health Services Office - CHSO",
      value: "2",
    },
    {
      name: "Public Employment Service Office - PESO",
      value: "3",
    },
    {
      name: "City Mayor's Office - CMO",
      value: "4",
    },
  ];

  subOfficeTypes = [
    {
      name: "Laboratory",
      value: "1",
    },
    {
      name: "Doctor",
      value: "2",
    },
    {
      name: "Sanitation",
      value: "3",
    },
    {
      name: "Scheduler",
      value: "4",
    },
  ];

  hidePassword: boolean = true;
  signUpForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    private enumService: EnumService,
    private fb: FormBuilder,
    private evaluatorService: EvaluatorService,
    private toast: ToastNotificationService,
    private router: Router
  ) {
    this.signUpForm = this.fb.group(
      {
        firstName: new FormControl("", [Validators.required]),
        lastName: new FormControl("", [Validators.required]),
        email: new FormControl("", [Validators.required]),
        officeType: new FormControl("", [Validators.required]),
        jobTitle: new FormControl("", [Validators.required]),
        subOffice: new FormControl(""),
        password: new FormControl("", [Validators.required]),
        confirmPassword: new FormControl("", [Validators.required]),
      },
      {
        validator: this.passwordMatchValidator,
      }
    );
  }

  ngOnInit() {
    this.signUpForm.get("officeType").valueChanges.subscribe((value) => {
      if (value == "2") {
        this.signUpForm.get("subOffice").setValidators([Validators.required]);
      } else {
        this.signUpForm.get("subOffice").clearValidators();
        this.signUpForm.get("subOffice").setValue("");
      }

      this.signUpForm.get("subOffice").updateValueAndValidity();
    })
  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get("password").value;
    const confirmPassword = group.get("confirmPassword").value;

    if (password === confirmPassword) {
      return null;
    } else {
      return { mismatch: true };
    }
  }

  onRegister() {
    this.isLoading = true;
    let value = this.signUpForm.value;
    const data = {
      email: value.email,
      firstName: value.firstName,
      lastName: value.lastName,
      jobTitle: value.jobTitle,
      subOffice: value.subOffice ? value.subOffice : 0,
      office: value.officeType,
      password: value.password,
    };
     this.evaluatorService.evaluatorRegister(data).subscribe((res) => {
      this.isLoading = false;
      this.toast.openSuccess("Registration successful!");
      setTimeout(() => {
        this.router.navigateByUrl("/evaluator/success");
      }, 1500);
    });
  }
}
